<p>dashboard-additional-info-section works!</p>
